import createIcon from '../../createIcon';

/**
 * @component @name SpeakerNotes
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMkg0QzIuOSAyIDIuMDEgMi45IDIuMDEgNEwyIDIyTDYgMThIMjBDMjEuMSAxOCAyMiAxNy4xIDIyIDE2VjRDMjIgMi45IDIxLjEgMiAyMCAyWk04IDE0SDZWMTJIOFYxNFpNOCAxMUg2VjlIOFYxMVpNOCA4SDZWNkg4VjhaTTE1IDE0SDEwVjEySDE1VjE0Wk0xOCAxMUgxMFY5SDE4VjExWk0xOCA4SDEwVjZIMThWOFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SpeakerNotes = createIcon('SpeakerNotes', [
  [
    'path',
    {
      d: 'M20 2H4C2.9 2 2.01 2.9 2.01 4L2 22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM8 14H6V12H8V14ZM8 11H6V9H8V11ZM8 8H6V6H8V8ZM15 14H10V12H15V14ZM18 11H10V9H18V11ZM18 8H10V6H18V8Z',
      key: 'z0txzs',
    },
  ],
]);

export default SpeakerNotes;
